import {auto} from 'async'
import R from 'ramda'
import {defineMessages} from 'react-intl'

import {getList, getSummaries} from '../api/search'

import fetchLikes from './fetchLikes'
import toggleLoadingEstates from './toggleLoadingEstates'
import addNotification from './addNotification'

import {toApi} from '../utils/apiMapper'


const matchs = ({estateIdsRes}, cb) => {
  const {results} = estateIdsRes
  cb(null, results)
}
const extractIds = ({matchs}, cb) => {
  cb(null, R.pluck('id', matchs))
}

const getIdsToFetch = getState => ({estatesIds}, cb) => {
  const isInCache = id => R.path(['estates', id, 'summary'], getState())
  const summariesToFetch = R.reject(isInCache, estatesIds)
  cb(null, summariesToFetch)    
}

const queryMatchingIds = ({apiQuery}, cb) => getList(apiQuery, cb)

const fetchSummaries = ({idsToFetch}, cb) => {
  if(R.isEmpty(idsToFetch)) {
    return cb(null, [])
  }
  getSummaries(idsToFetch, cb)
}
const applyApiMapper = (query, getState) => cb => cb(null,  toApi(query, getState()))
const computeStats = ({estateIdsRes}, cb) => cb(null, R.pick(['time', 'nbResults', "nbLikes"], estateIdsRes))

const onComplete = (dispatch, now) => (err, {stats, estateSummaries, matchs, idsToFetch, estatesIds}) => {
  if(err) { 
    dispatch(addNotification(notification))
    return console.error('Error', err)
  }
  const then = Date.now()

  dispatch({type: 'search_results', payload: {...stats, time: then - now}})
  dispatch({type: 'load_estates', estates: estateSummaries})
  dispatch({type: 'change_estates_to_show_in_list', matchs})
  dispatch(fetchLikes(estatesIds))
  dispatch(toggleLoadingEstates())  
}
const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "Failed to execute the your query, try changing some of the parameters", 
    defaultMessage: "Failed to execute the your query, try changing some of the parameters"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}


export default query => (dispatch, getState)  => {

  const now = Date.now() 
  dispatch(toggleLoadingEstates())
  dispatch({type: 'show_estate_list'})

  auto({
    apiQuery:        applyApiMapper(query, getState),
    stats:           ['estateIdsRes', computeStats],
    estateIdsRes:    ['apiQuery', queryMatchingIds],
    matchs:          ['estateIdsRes', matchs],
    estatesIds:      ['matchs', extractIds],
    idsToFetch:      ['estatesIds', getIdsToFetch(getState)],
    estateSummaries: ['idsToFetch', fetchSummaries],
  }, onComplete(dispatch, now))
}



/** WEBPACK FOOTER **
 ** ./app/actions/listSearch.js
 **/